const getMonthNumber = (date) => date.getMonth() + 1;
const getWithLeadingZero = (num) => `0${num}`.slice(-2);
export default {
  htmlDecode(input) {
    var e = document.createElement("div");
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  },
  isBlank(str) {
    return !str || /^\s*$/.test(str);
  },
  formatDate(date) {
    return (
      "" +
      getWithLeadingZero(date.getDate()) +
      "." +
      getWithLeadingZero(getMonthNumber(date)) +
      "."
    );
  },
  formatTime(date) {
    return (
      "" +
      getWithLeadingZero(date.getHours()) +
      "." +
      ("" + date.getMinutes() + "0").slice(0, 2)
    );
  },
  clone(f) {
    return JSON.parse(JSON.stringify(f));
  },
  arrayContainsIdenticalItems(array1, array2) {
    if (array1.length === array2.length) {
      return array1.every((element) => {
        if (array2.includes(element)) {
          return true;
        }

        return false;
      });
    }
    return false;
  },
  validateRadius(unit) {
    var r = {'M': 6371009, 'KM': 6371.009, 'MI': 3958.761, 'NM': 3440.070, 'YD': 6967420, 'FT': 20902260};
    if ( unit in r ) return r[unit];
    else return unit;
  },
  distance(lat1, lon1, lat2, lon2, unit) {
    if ( unit === undefined ) unit = 'KM';
    var r = this.validateRadius(unit); 
    lat1 *= Math.PI / 180;
    lon1 *= Math.PI / 180;
    lat2 *= Math.PI / 180;
    lon2 *= Math.PI / 180;
    var lonDelta = lon2 - lon1;
    var a = Math.pow(Math.cos(lat2) * Math.sin(lonDelta) , 2) + Math.pow(Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lonDelta) , 2);
    var b = Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lonDelta);
    var angle = Math.atan2(Math.sqrt(a) , b);    
    return angle * r;
  }
};
